import { Button, Input, Space } from "antd/lib";
import XStroke from "../../../public/icons/XStroke";
import React from "react";
import { useSearch } from "@/hooks/useSearch";
import { FilterTypes } from "@/constants/common";
import { useTranslation } from "react-i18next";

interface SearchProps {
  filterType: FilterTypes;
  placeholder?: string;
}

const Search: React.FC<SearchProps> = ({ filterType, placeholder }) => {
  const {
    searchValue,
    searchInputChangeHandler,
    searchHandler,
    resetInputSearchHandler,
    showSearchInputReset,
    searchUrlParam,
  } = useSearch(filterType);
  const { t } = useTranslation();

  return (
    <>
      <Space.Compact className="search-compact" style={{ width: "100%" }}>
        <Input
          onPressEnter={searchHandler}
          value={searchValue}
          onChange={searchInputChangeHandler}
          placeholder={placeholder || t("common.filters.searchPlaceholder")}
          style={{ height: 36 }}
          allowClear
        />
        <Button
          className="search-btn"
          style={{ height: 36 }}
          disabled={!searchValue.trim().length || searchValue === searchUrlParam}
          icon={<i className="icon-search_stroke" color={"#888888"} onClick={searchHandler} />}
        />
      </Space.Compact>
      {showSearchInputReset && (
        <Button
          type="text"
          onClick={resetInputSearchHandler}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            minHeight: "36px",
            paddingTop: "4px",
            paddingBottom: "4px",
          }}
          icon={<XStroke />}
        >
          {t("common.filters.searchResetBtn")}
        </Button>
      )}
    </>
  );
};

export default Search;
